import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {
    FL_DESCRIPTION,
    FL_TITLE,
} from "../../../../components/i18n/formLabels";
import {
    PH_DESCRIPTION,
    PH_TITLE,
} from "../../../../components/i18n/placeHolders";
import {LangController} from "../../../../components/tabs/langController";

const ActivitySectionLangs = props => {

    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label>{ FL_TITLE }</Label>
                    <Input
                        type="textarea"
                        rows={'1'}
                        name="title"
                        placeholder={ PH_TITLE }
                        value={ child.title || '' }
                        onChange={ e => onInputChange(e, child.lang) }
                        disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            {/*<Col md="4">*/}
            {/*    <FormGroup>*/}
            {/*        <Label>{FL_IMAGE}</Label>*/}
            {/*        <Input*/}
            {/*            type="text"*/}
            {/*            name="image"*/}
            {/*            placeholder={PH_IMAGE}*/}
            {/*            value={ child.image }*/}
            {/*            onChange={ e => onInputChange(e, child.lang) }*/}
            {/*            disabled={ disableInputs }*/}
            {/*        />*/}
            {/*    </FormGroup>*/}
            {/*</Col>*/}
            <Col md="12">
                <FormGroup>
                    <Label>{FL_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        name="longDescription"
                        rows={'12'}
                        placeholder={PH_DESCRIPTION}
                        value= { child.longDescription || '' }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>{'Recomendaciones'}</Label>
                    <Input
                        type="textarea"
                        name="recomendationMax"
                        rows={'8'}
                        placeholder={'Recomendaciones'}
                        value= { child.recomendationMax || '' }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>{'Incluye'}</Label>
                    <Input
                        type="textarea"
                        name="include"
                        rows={'8'}
                        placeholder={PH_DESCRIPTION}
                        value= { child.include || '' }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>


    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default ActivitySectionLangs